export enum SchoolChapterType {
  Start = 0,
  Regular = 1,
  Exam = 2,
}
